import {Component, Input, OnInit} from "@angular/core";
import "rxjs/Rx";

declare var $: any;

@Component({
    selector: 'app-loading',
    templateUrl: './view/loading.component.html',
    styleUrls: ['./css/loading.component.scss']
})
export class LoadingComponent implements OnInit {

    @Input() modulo;
    @Input() showText = true;

    constructor() {

    }

    ngOnInit() {

    }


}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/autenticacion/loadingScreen/loading.component.ts